import { z } from 'zod';
export const ChatProjectSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    sessionCount: z.number().int().nonnegative(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ChatProjectListSchema = z.object({
    projects: z.array(ChatProjectSchema),
});
export const CreateChatProjectRequestSchema = z.object({
    name: z.string().trim().min(1).max(80),
    description: z.string().trim().max(500).optional(),
});
export const RenameChatProjectRequestSchema = z.object({
    name: z.string().trim().min(1).max(80),
    description: z.string().trim().max(500).nullable().optional(),
});
/**
 * 채팅 세션을 다른 프로젝트로 이동 (또는 미분류로 환원).
 * UI 에서 드래그 드롭 = 프로젝트 → 프로젝트 만 트리거되지만, 프로젝트 삭제 시 cleanup
 * 경로 등에서 `null` 도 허용한다.
 */
export const MoveChatSessionRequestSchema = z.object({
    projectId: z.string().uuid().nullable(),
});
//# sourceMappingURL=chat-projects.js.map